import React from 'react'
import NowPlaying from './../components/now_playing'
//import ComingSoon from './../components/coming_soon'
import Theatre from './../components/theatre'
//import StudentSpotlight from './../components/student_spotlight'
import Sponsors from './../components/sponsors'
// import Banner from './../components/banner'

class Home extends React.Component {
	render() {
		return (
			<div className="page">
				<NowPlaying />
				{/* <div className="meet-and-greet-container">
                	<div className="container">
						<img src="images/bikini-bottom-festival.jpg" alt="Biking Bottom Festival" />
					</div>
				</div> */}
				{/*<Banner /> */}
				{/*<ComingSoon /> */}
				{/*<StudentSpotlight /> */}
				<Theatre />
				<Sponsors />

				{/*
				<section className="container">
					<h2>Our Supporters</h2>
					<p>Please support these local businesses that support us!</p>
					<Link to="/">
						<img src="images/_grey_placeholder.png" alt="Social Feed" />
					</Link>
				</section>
				*/}

				{/*
				<section className="container">
					<h2>What's Going on</h2>
					<div className="fb-page"
							data-href="https://www.facebook.com/Downingtown-East-Theatre-151960198191336"
							data-tabs="timeline" data-width="500"
							data-small-header="true"
							data-adapt-container-width="true"
							data-hide-cover="false"
							data-show-facepile="true">
							<blockquote cite="https://www.facebook.com/facebook" className="fb-xfbml-parse-ignore">
								<a href="https://www.facebook.com/facebook">Facebook</a>
							</blockquote>
					</div>
				</section>
				*/}
			</div>
		)
	}
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/home.js